import Vue from "vue";
import Router from "vue-router";

import Login from "@/views/login";
import ResetPassword from "@/views/resetPassword";
import Home from "@/views/home/index.vue";
import MyQuestionaire from "@/views/questionaire/MyQuestionaire.vue";
import Questionnairefilling from "@/views/questionaire/Questionnairefilling.vue";
import CompleteQuestionnaire from "@/views/questionaire/CompleteQuestionnaire.vue";
import AbilityGrowthRecord from "@/views/questionaire/AbilityGrowthRecord.vue";
import CapacityWarning from "@/views/questionaire/CapacityWarning.vue";
import AchievingCourses from "@/views/questionaire/AchievingCourses.vue";
import AchievementAnalysis from "@/views/questionaire/AchievementAnalysis.vue";
import Questionnairedetails from "@/views/questionaire/Questionnairedetails.vue";

import UserInfo from "@/views/userInfo";
import Message from "@/views/message";
import Objectives from "@/views/objectives";
import GraduationRequirements from "@/views/graduationRequirements";
import IndicatorPoints from "@/views/indicatorPoints";
import Syllabus from "@/views/syllabus";
import CourseSystem from "@/views/courseSystem";
import Post from "@/views/post";
import Studentclaims from "@/views/student";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/resetPassword",
      name: "resetPassword",
      component: ResetPassword
    },
    {
      path: "/",
      name: "home",
      component: Home
    },
    //我的问卷
    {
      path: "/myQuestionaire",
      name: "myQuestionaire",
      component: MyQuestionaire
    },
    // 问卷填写
    {
      path: "/questionnairefilling",
      name: "questionnairefilling",
      component: Questionnairefilling
    },
    // 提交问卷
    {
      path: "/completeQuestionnaire",
      name: "completeQuestionnaire",
      component: CompleteQuestionnaire
    },
    // 问卷详情
    {
      path: "/questionnairedetails",
      name: "questionnairedetails",
      component: Questionnairedetails
    },
    // 能力成长记录
    {
      path: "/abilityGrowthRecord",
      name: "abilityGrowthRecord",
      component: AbilityGrowthRecord
    },
    // 能力预警记录
    {
      path: "/capacityWarning",
      name: "capacityWarning",
      component: CapacityWarning
    },
    // 课程达成记录
    {
      path: "/achievingCourses",
      name: "achievingCourses",
      component: AchievingCourses
    },
    // 成绩分析
    {
      path: "/achievementAnalysis",
      name: "achievementAnalysis",
      component: AchievementAnalysis
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: UserInfo
    },
    {
      path: "/message",
      name: "message",
      component: Message
    },
    {
      path: "/objectives",
      name: "objectives",
      component: Objectives
    },
    {
      path: "/graduationRequirements",
      name: "graduationRequirements",
      component: GraduationRequirements
    },
    {
      path: "/indicatorPoints",
      name: "indicatorPoints",
      component: IndicatorPoints
    },
    {
      path: "/syllabus",
      name: "syllabus",
      component: Syllabus
    },
    {
      path: "/courseSystem",
      name: "courseSystem",
      component: CourseSystem
    },
    {
      path: "/post",
      name: "post",
      component: Post
    },
    {
      path: "/studentclaims",
      name: "Studentclaims",
      component: Studentclaims
    }
  ]
});
